<div *ngIf="nyhetList" class="page-container">
  <app-cards [cards]="nyhetList" [page]="null" [useCustomOrdering]="false"></app-cards>
</div>

<div *ngIf="!nyhetList|| isLoading" class="page-container page">
  <h2>Vennligst vent mens nyhetsarkivet lastes. Dette kan ta litt tid.</h2>
</div>

